import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArchive = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_892_20129",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 24,
		height: 25,
		children: /* @__PURE__ */ _jsx("rect", {
			y: .0292969,
			width: 24,
			height: 24
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_892_20129)",
		children: /* @__PURE__ */ _jsx("path", { d: "M5.3077 20.5292C4.80257 20.5292 4.375 20.3542 4.025 20.0042C3.675 19.6542 3.5 19.2266 3.5 18.7215V7.1062C3.5 6.89465 3.53045 6.7033 3.59135 6.53215C3.65225 6.361 3.73975 6.19978 3.85385 6.0485L5.17693 4.4639C5.29744 4.31261 5.44648 4.20236 5.62403 4.13315C5.80159 4.06391 5.99102 4.0293 6.1923 4.0293H17.8077C18.0089 4.0293 18.1984 4.06071 18.3759 4.12352C18.5535 4.18634 18.7025 4.2998 18.823 4.4639L20.1269 6.0485C20.2474 6.19978 20.3397 6.361 20.4038 6.53215C20.4679 6.7033 20.5 6.89465 20.5 7.1062V18.7215C20.5 19.2266 20.325 19.6542 19.975 20.0042C19.625 20.3542 19.1974 20.5292 18.6923 20.5292H5.3077ZM5.39997 6.52925H18.6L17.75 5.52925H6.24997L5.39997 6.52925ZM4.99997 8.02922V18.7215C4.99997 18.7984 5.03202 18.869 5.09612 18.9331C5.16024 18.9972 5.23077 19.0292 5.3077 19.0292H18.6923C18.7692 19.0292 18.8397 18.9972 18.9038 18.9331C18.9679 18.869 19 18.7984 19 18.7215V8.02922H4.99997ZM12 17.6253L15.6538 13.9715L14.6 12.9177L12.75 14.7677V10.3177H11.25V14.7677L9.39998 12.9177L8.34615 13.9715L12 17.6253Z" })
	})]
});
export default SvgArchive;
